import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SalienteLibrarySharedModule } from "@saliente/library";
import { ClientFormsService } from "../client-forms.service";
import { MP20242025M2PFormComponent } from "./mp2024-2025-m2p-form.component";
import { MP2024FormComponent } from "./mp2024-form.component";
import { MP2024RoutesLoaderGuard } from "./mp2024RoutesLoader.guard";
import { MP2025P2MFormComponent } from "./mp2025-p2m-form.component";

@NgModule({
    imports: [
		CommonModule, FormsModule, SalienteLibrarySharedModule
	],
	providers: [
		ClientFormsService, MP2024RoutesLoaderGuard
	],
	declarations: [
		MP2024FormComponent, MP2025P2MFormComponent, MP20242025M2PFormComponent
	],
	exports: [
		MP2024FormComponent, MP2025P2MFormComponent, MP20242025M2PFormComponent
	]
})
export class MP2024FormSharedModule { }